/**
 * @generated SignedSource<<ed1273abefb712fdfa42f673c2b2cda3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarTeamEventCreateScreenQuery$variables = {
  teamId: string;
};
export type CalendarTeamEventCreateScreenQuery$data = {
  readonly store: {
    readonly team: {
      readonly calendars: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventCreateScreenComponent_storeCalendars">;
      }>;
    } | null;
    readonly timezone: string;
  };
};
export type CalendarTeamEventCreateScreenQuery = {
  response: CalendarTeamEventCreateScreenQuery$data;
  variables: CalendarTeamEventCreateScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "includeExternal",
    "value": true
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarTeamEventCreateScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "calendars",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CalendarTeamEventCreateScreenComponent_storeCalendars"
                  }
                ],
                "storageKey": "calendars(includeExternal:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarTeamEventCreateScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "calendars",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isExternal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  }
                ],
                "storageKey": "calendars(includeExternal:true)"
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86318e96729f3332e838eaa4d3bc3786",
    "id": null,
    "metadata": {},
    "name": "CalendarTeamEventCreateScreenQuery",
    "operationKind": "query",
    "text": "query CalendarTeamEventCreateScreenQuery(\n  $teamId: ID!\n) {\n  store {\n    timezone\n    team(id: $teamId) {\n      calendars(includeExternal: true) {\n        ...CalendarTeamEventCreateScreenComponent_storeCalendars\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment CalendarTeamEventCreateScreenComponent_storeCalendars on StoreCalendar {\n  id\n  isExternal\n  ...CalendarTeamEventEditComponent_storeCalendars\n}\n\nfragment CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars on StoreCalendar {\n  id\n  title\n  color\n  isExternal\n}\n\nfragment CalendarTeamEventEditComponent_storeCalendars on StoreCalendar {\n  id\n  title\n  color\n  ...CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars\n}\n"
  }
};
})();

(node as any).hash = "68182d77fa7ab568cbeadd4813ea3460";

export default node;
